import { createSlice } from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: "app",
  initialState: {
    appType: null,
  },
  reducers: {
    setAppType: (state, action) => {
      state.appType = action.payload.appType;
    },
  },
});

export const {
  setAppType,
} = appSlice.actions;

export const selectAppType = (state) => {
  return state.app.appType;
};

export const selectAppTypeCaption = (state) => {
  switch (state.app.appType) {
    case "scholarships":
      return "Scholarships";
    case "aims":
      return "AIMS";
    case "ams":
      return "AMS";
    default:
      return state.app.appType;
  }
};

export default appSlice.reducer;
